export default "__VITE_ASSET__Bv56JlYO__"